import React from 'react';
import { StyledIconBox, StyledText, StyledContainer } from './icon-textbox.style';
import LightbulbSvg from '../../../../public/static/icons/lightingbulb.svg';

export const IconTextbox = ({ text }: { text: string }) => {
    return (
        <StyledContainer>
            <StyledIconBox>
                <LightbulbSvg />
            </StyledIconBox>
            <StyledText>
                <p>{text}</p>
            </StyledText>
        </StyledContainer>
    );
};
